
export default {
  name: 'FaqItem',
  props: {
    question: {
      type: String,
      required: true
    },
    answer: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      open: false
    }
  }
}
